import { api } from '@/services/api/AxiosBaseService'

export type VacationSituation = 'AGENDADAS' | 'EM_ANDAMENTO' | 'CONCLUIDAS'

/** Período de férias do usuário (datas inclusivas). */
export interface UserVacation {
  id: string
  startDate: string
  endDate: string
  days: number
  situation: VacationSituation
  notes: string | null
  createdBy: string | null
  createdAt: string | null
}

export interface UserVacationPayload {
  startDate: string
  endDate: string
  notes: string | null
}

const base = (userId: string) => `/administractive/users/${userId}/vacations`

export const UserVacationsService = {
  async list(userId: string): Promise<UserVacation[]> {
    const r = await api.get<{ data: UserVacation[] }>(base(userId))
    return r.data.data
  },
  async create(userId: string, payload: UserVacationPayload): Promise<UserVacation> {
    const r = await api.post<{ data: UserVacation }>(base(userId), payload)
    return r.data.data
  },
  async update(userId: string, id: string, payload: UserVacationPayload): Promise<UserVacation> {
    const r = await api.put<{ data: UserVacation }>(`${base(userId)}/${id}`, payload)
    return r.data.data
  },
  async destroy(userId: string, id: string): Promise<void> {
    await api.delete(`${base(userId)}/${id}`)
  },
}
